export default function getResource(label, vars = []) {
    const resources = {
        promoWarning: 'Avertissement code promotionnel/de récompense',
        promoConfirmationTitle: 'Promotion utilisée',
        promoConfirmationMessage: 'Votre promotion a été ajoutée à votre panier.',
        ok: 'OK',
        promoErrorTitle: 'Erreur liée à la promo',
        promoOopsTitle: 'Oups!',
        gotIt: 'Compris',
        oops: 'Oups!',
        gwpErrorMessage: 'Nous ne sommes pas en mesure de charger les options de cadeaux pour le moment. Veuillez réessayer plus tard.',
        gwpConfigError: 'Cette promotion n’est pas configurée correctement. Veuillez communiquer avec le service à la clientèle ou réessayez plus tard.',
        noGwpAvailable: 'Aucune option de cadeau n’est disponible en ce moment. Veuillez réessayer plus tard.'
    };

    return resources[label];
}
